export const selectDealsGoLive = state => state?.deals?.goLive
